<template>
    <div class="orderMsg">
        <div class="orderImg"><img src="../../assets/images/xuebi_24.png" alt=""></div>
        <!-- <div class="orderImg" v-if="theWayTo == 1"><img :src="this.weburl+orderData.original_img" alt=""></div>
        <div class="orderImg" v-else><img :src="this.weburl+orderData.original_img" alt=""></div> -->
        <div class="orderDetail" v-if="theWayTo == 1"><h3>{{orderData.goods_name}}</h3>
        <p>使用时间：{{orderData.chooseDate}}</p>
            <span class="orderPrice">￥{{orderData.shop_price}}</span>
            <span class="orderNum">X{{orderData.goods_num}}</span>
        </div>

        <div class="orderDetail" v-else><h3>{{orderData.goods_name}}</h3>
        <p>使用时间：{{this.handleUseTimeFormat(orderData.occ_date)}}</p>
            <span class="orderPrice">￥{{orderData.goods_price}}</span>
            <span class="orderNum">X{{orderData.goods_num}}</span>
        </div>
    </div>
</template>

<script>
    export default {
        name: "orderMsg",
        props:["orderData","theWayTo"],
        created:function () {
            
        },
        computed:{
            weburl: function () {
                return this.$store.state.weburl;
            }
        },
        methods:{
            handleUseTimeFormat: function (time) {
                var formatTime = new Date(time*1000);
                var formatTimeY = formatTime.getFullYear();
                var formatTimeM = formatTime.getMonth()+1;
                var formatTimeD = formatTime.getDate();
                formatTime = formatTimeY + "/" + formatTimeM + "/" + formatTimeD;
                return formatTime;
            }
        }
    }
</script>

<style scoped lang="less">
    @import '../../assets/less/common.less';
  .orderMsg{
    //   margin-top: 60px;
      width: @width;
      height: 98px;
      background: @bg;
      padding: 10px;
     .box-sizing;
  }
 .orderImg{
     float: left;
     width: 32%;
     height: @width;
     background: red;
     img{
         .img;
     }
 }
  .orderDetail{
        float: left;
        width: 68%;
        height: 100%;
        .box-sizing;
        padding-left: 15px;
        position: relative;
      h3{
          font-size:1rem;
          margin-bottom: .2rem;
      }
      p{
          color:@word;
          font-size:@font - .2;
      }
  }
    .orderPrice ,  .orderNum {
        position: absolute;
        bottom: 0;
        font-size:@font - .2;
    }
  .orderPrice{
        left:15px;
        color:@subject_color;
  }
  .orderNum{
        right:0;
  }
</style>
